import StationAdoptStore from "../stationadopt/StationAdoptStore";
import {getJobs} from "./PressJobsStore";
import StationsStore from "./StationsStore";

class StationDataStore {

    async getAdoptedStationData(hours, limit) {

        const adoptInfo = await new StationAdoptStore().read();
        if (!adoptInfo)
            throw 'Station not assigned';

        const stationInfo = await new StationsStore().findById(adoptInfo.data.stationId);
        if (!stationInfo)
            throw 'Station id not found ' + adoptInfo.stationId;

        const jobs = await getJobs(stationInfo.data, hours, limit);

        stationInfo.data.pressJobs = jobs.data;

        return stationInfo;


    }

}

export default StationDataStore;

